import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface LoadingDialogProps {}
const LoadingDialog = (props: LoadingDialogProps) => {
  return (
    <>
      <p className="text-4xl text-center flex flex-col items-center">
        <FontAwesomeIcon icon={faCircleNotch} spin className="text-primary" />
        <span className="text-gray-500 sans-serif text-2xl mt-2">Loading</span>
      </p>
    </>
  );
};

export default LoadingDialog;
